// UI
import Image from 'ui3/Image/Image';
// Styles
import styles from './StreamImage.module.scss';

type StreamImageProps = {
  imageURL: string | null;
  name: string | null;
  className?: string;
  wrapperClassName?: string;
};

const StreamImage = ({
  imageURL,
  name,
  className,
  wrapperClassName,
}: StreamImageProps) => {
  const useWrapper = Boolean(wrapperClassName);

  return (
    <div className={wrapperClassName || styles.imageContainer}>
      {useWrapper ? (
        <div className={styles.imageWrapper}>
          <Image
            className={className || styles.image}
            src={imageURL || ''}
            alt={name || ''}
            title={name ? `Watch ${name}` : undefined}
          />
        </div>
      ) : (
        <Image
          className={className || styles.image}
          src={imageURL || ''}
          alt={name || ''}
        />
      )}
    </div>
  );
};

export default StreamImage;
